import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 512"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "m89.45 87.5 143.1 152a23.94 23.94 0 0 1 6.562 16.5 23.96 23.96 0 0 1-6.562 16.5l-143.1 152c-9.12 9.6-24.31 10-33.93.9-9.688-9.125-10.03-24.38-.937-33.94l128.4-135.5-128.4-135.5c-9.093-9.56-8.753-24.71.937-33.9 9.62-9.09 24.81-8.69 33.93.94",
      style: {"fill":"var(--fa-primary-color, currentColor)","opacity":"var(--fa-primary-opacity, 1)"}
    }, null, -1)
  ])))
}
export default { render: render }